<template>
    <v-container class="ma-0 pa-0 login_background" style="background-color: #1b1b1b; width: 100%; height: 100%;" fluid>
        <v-img :src=background_img style="height: 100%" cover>
            <v-row class="ma-0 pa-0" style="height: 100%; background-color: #1b1b1b90;">
                <v-row class="ma-0 pa-0" style="height: 65%;" justify="space-around">
                    <v-col cols="6" align-self="center">
                        <v-card outlined class="pa-6 pt-12 pb-12 ma-0 login_card" style="background-color: #1b1b1b;">
                            <v-form v-if="!token_loading" class="ma-0 pa-4">
                                <v-row class="ma-0 pa-0">
                                    <v-spacer></v-spacer>
                                    <v-col cols="auto">
                                        <v-img :src=main_logo_inverterd contain max-width="250px"></v-img>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                </v-row>
                                <v-row class="ma-0 pa-0">
                                    <v-spacer></v-spacer>
                                    <v-col cols="auto">
                                        <span class="loginFormTextSubtitle">Welcome to Docma Enterprise</span>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                </v-row>
                                <v-row class="mt-6">
                                    <v-col cols="12">
                                        <v-row class="ma-0 pa-0">
                                            <v-spacer></v-spacer>
                                            <v-col class="ma-0 pa-0" cols="10" style="width: 100%">
                                                <v-btn outlined x-large class="ma-4 loginFormTextStyle" color="white" @click="login">Log In / Sign Up</v-btn>
                                            </v-col>
                                            <v-spacer></v-spacer>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-form>
                            <v-progress-circular indeterminate size="50" v-else></v-progress-circular>
                        </v-card>
                    </v-col>
                </v-row>
            </v-row>
        </v-img>
    </v-container>
</template>

<script>
import docma_logo from "@/assets/docma-logo-white-red.svg";
import hex from "@/assets/footer-hex.svg";
import background from "@/assets/login_background.jpg"

export default {
    name: "LoginPage",
        data() {
            return {
                token_loading: false,
                main_logo_inverterd: docma_logo,
                hex_img: hex,
                background_img: background,

                showpass: false,
        };
    },
    mounted() {
        if(this.$auth.isAuthenticated && this.$router.route !== "/welcome") {
            this.$router.push("/welcome");
        }
    },
    methods: {
        login() {
        this.$auth.loginWithRedirect();
        },
        // Log the user out
        logout() {
        this.$auth.logout({
                logoutParams: {
                returnTo: window.location.origin,
                },
            });
        },
    },
};
</script>

<style scoped>
    .login_background{
        background-image: url('~@/assets/login_background.jpg') no-repeat center center fixed; 
        background-size: cover;
        height: 100vh;
    }
    .loginFormTextStyle {
        font-family: "Poppins" !important;
        width: 90%;
        color: white;
    }
    .loginFormTextSubtitle {
        font-family: "Poppins" !important;
        font-family: 200;
        font-size: 1.5em;
        width: 90%;
        color: white;
    }
    .loginFormAlerts{
        font-family: 'Poppins' !important;
        position: absolute; 
        width: 100%;
        z-index: 4;
    }
    .login_card {
        min-width: 300px; 
        max-width: 50vw; 
        z-index: 3;
    }
    .login_top_hex {
        transform: translateY(30%) translateX(-20%);
        z-index: 0;
        max-width: 150px;
    }
    .login_bottom_hex {
        transform: translateY(-30%) translateX(30%) rotate(240deg);
        z-index: 0;
        max-width: 150px;
    }
</style>